import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators ,NgForm} from '@angular/forms';
import { CommonService } from 'app/auth/service/common.service';
import Swal from 'sweetalert2';
import { documentType, ParentParameters, statusCode,applicationFrom } from '../../../auth/models/commonEnum';
import { MyApplicationService } from '../my-application.service';
import { NgbCalendar, NgbDateParserFormatter, NgbDateStruct, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';

@Component({
  selector: 'app-customer-list',
  templateUrl: './customer-list.component.html',
  styleUrls: ['./customer-list.component.scss']
})
export class CustomerListComponent implements OnInit {

  @Input()fromPageType:any| undefined;
	public contentHeader;
  	public pageAdvancedEllipses = 1;
	public pageAdvancedNoEllipses = 8;
	public searchform: FormGroup;
	public addExpertForm: FormGroup;
	public subjectType = [];
	public userList: any[];
	public totalRecords: any;
	public pageSize: any;
	public submitted = true;
	public statusText: string;
	public status : any;
	public pageSizeList = [
		{ pageSizeValue: "10" },
		{ pageSizeValue: "25" },
		{ pageSizeValue: "50" },
		{ pageSizeValue: "100" }
	];
	public sortByList = [
		{ sortByName: "Ascending", sortByValue: "ASC" },
		{ sortByName: "Descending", sortByValue: "DESC" }
	];

  	constructor(private _formBuilder: FormBuilder,
		private _commonService: CommonService,
		private _MyApplicationService: MyApplicationService,
		public formatter: NgbDateParserFormatter,
		private calendar: NgbCalendar,
		private http: HttpClient,
		private _router: Router,
		private modalService: NgbModal) { 
		this.searchform = this._formBuilder.group({
			SearchText: [''],
			Subject:[],
			SortOrder: ["DESC"],
			PageNumber: [1],
			PageSize: [10]
		})
		this.addExpertForm = this._formBuilder.group({
			
		})
  	}

		ngOnInit(): void {
			this.loadSubjectType();
			this.getCustomerList();

			this.contentHeader = {
				headerTitle: 'All Registered Users',
				actionButton: true,
				breadcrumb: {
					type: '',
					links: [
						{
							name: 'All Registered Users',
							isLink: true,
							link: '/customer-list'
						},
					]
				}
			};
		}

  		/**
		 * function for search data.
		 ***/
		search() {
			let defaultPageSize = this.searchform.controls.PageSize.value != undefined ? this.searchform.controls.PageSize.value : 10;
			const data = {
				SearchText: this.searchform.controls.SearchText.value,
				subjectType: this.searchform.controls.Subject.value,
				sortOrder: (this.searchform.controls.SortOrder.value == null ? "DESC" : this.searchform.controls.SortOrder.value),
				pageNumber: this.previousPage != undefined ? this.previousPage : this.searchform.controls.PageNumber.value,
				pageSize: defaultPageSize
			}
			
			this._MyApplicationService.getCustomerList(data).subscribe((result: any) => {
				this.userList = [];
				if (result.statusCode == statusCode.SUCCESS) {
					this.userList = result["data"]["userlist"];
					this.totalRecords = result["data"]["userCount"];
					this.pageSize = defaultPageSize; 
				}
				else {
					this.totalRecords = 0;
					this.userList = [];
					Swal.fire({
						icon: 'error',
						title: 'Error!',
						text: result["message"],
						customClass: {
							confirmButton: 'btn btn-error'
						}
					});
				}
			});
		}
		/**
		 * function for reset filter.
		 ***/
		resetFilter() {
			this.searchform.reset();
			this.search();
		}

		/**
		 * function for load data based on pagination.
		 ***/
		previousPage: any;
		loadPage(page: number) {
			if (page !== this.previousPage) {
				this.previousPage = page;
				this.search();
			}
		}

		/**
		 * function for load status type dropdown data.
		 ***/
		loadSubjectType() {
			this._commonService.getParameterSettings(ParentParameters.SUBJECTAREA).subscribe((result: any) => {
				this.subjectType = [];
				if (result.statusCode == statusCode.SUCCESS) {
					result["data"]["response"].forEach(element => {
						this.subjectType.push({
							subjectTypeName: element.paraDescription,
							subjectTypeID: element.paraId
						});
					});
				}
			});
		}

		getCustomerList() {
			this.search();
		}

		/**
		 * function for open model popup for upload sanction latter document.
		 ***/
		addExpertModel(modalAE) {
			// this.raiseRequestform.reset();
			// var applicationID = id;
			// this.raiseRequestform.controls.ApplicationID.setValue(applicationID);
			this.modalService.open(modalAE, {
				centered: true,
				size: 'lg',
				scrollable: true
			});
		}

		closeModal() {
			this.submitted = false;
		}

		activeInActiveUser(isActive:number,id:Number){
			if(isActive == 0){
				this.status = 1;
				this.statusText = 'Active';
			}else{
				this.status = 0;
				this.statusText = 'InActive';
			}
			const data = {
				expertId : id,
				isActive : this.status
			}
			Swal.fire({
				text: 'Are you sure want to '+ this.statusText +' Status?',
				icon: 'warning',
				showCancelButton: true,
				confirmButtonText: 'Yes',
				cancelButtonText: 'No, keep it'
			}).then((result) => {
				if (result.value) {
					this._MyApplicationService.updateExpertStatus(data).subscribe((result: any) => {
						this.userList = [];
						if (result.statusCode == statusCode.SUCCESS) {
							Swal.fire(
								'Changes!',
								'User status updated successfully',
								'success'
							)
						}
					})
					this.getCustomerList();
				} else if (result.dismiss === Swal.DismissReason.cancel) {
					Swal.fire(
						'Cancelled',
						'Your status is not changed yet :)',
						'error'
					)
				}
			})
			
		}

}
